import { useEffect, useState } from "react";
import { BUILT_RELEASE_VERSION } from "../lib/appVersion";
import { isNativeApp } from "../lib/platform";

export function InstalledAppVersion() {
  const [label, setLabel] = useState(() => isNativeApp() ? "Reading version…" : `Version ${BUILT_RELEASE_VERSION}`);

  useEffect(() => {
    if (!isNativeApp()) return;
    let active = true;
    async function readInstalledVersion() {
      try {
        const { App } = await import("@capacitor/app");
        const installed = await App.getInfo();
        const version = typeof installed.version === "string" ? installed.version.trim() : "";
        const build = typeof installed.build === "string" ? installed.build.trim() : "";
        if (active) setLabel(version && build ? `Version ${version} · Build ${build}` : "Version unavailable");
      } catch {
        // A failed native read must not substitute the web assets' or server's version.
        if (active) setLabel("Version unavailable");
      }
    }
    void readInstalledVersion();
    return () => { active = false; };
  }, []);

  return <p className="text-xs text-mut py-3" role="status" aria-label="App version">{label}</p>;
}
